
export default function XLogo({
  size,
  color = 'black',
  className,
}: {
  size?: number;
  color?: string;
  className?: string;
}) {
  return (
    <svg
      width={size}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.2833 10.4065L23.2178 0H21.1006L13.3427 9.03585L7.14656 0H0L9.36984 13.6638L0 24.5767H2.11732L10.3098 15.0345L16.8534 24.5767H24L14.2827 10.4065H14.2833ZM11.3833 13.7842L10.4339 12.4236L2.88022 1.59709H6.1323L12.2282 10.3344L13.1776 11.695L21.1016 23.0522H17.8495L11.3833 13.7847V13.7842Z"
        fill={color}
      />
    </svg>
  );
}
